class NanoButtons extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const currentUrl = window.location.href;
    const pageHandle = currentUrl.split('/').pop() || 'home';

    this.updateSelectedButton(pageHandle);
    this.querySelectorAll('.filter-buttons').forEach(btn => {
      btn.addEventListener('click', () => {
        this.updateSelectedButton(btn.dataset.handle);
      });
    });
  }

  updateSelectedButton(pageHandle) {
    this.querySelectorAll('.filter-buttons').forEach(btn => {
      if (btn.dataset.handle === pageHandle) {
        btn.classList.remove('btn--outline');
        btn.classList.add('btn--primary');
      } else {
        btn.classList.remove('btn--primary');
        btn.classList.add('btn--outline');
      }
    });
  }
}

customElements.define('nano-buttons', NanoButtons);